module.exports = __webpack_public_path__ + "img/barbarariveros.68551fb8.jpg";